import { Form, Formik } from 'formik';

import { MenteeToMentorFormContent } from 'hb-react/frontoffice/apps/Mentoring/components/MenteeToMentorFormContent';
import { useCreateMenteeToMentor } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateMenteeToMentor';
import type {
  MentorProfile,
  Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { LockScreen } from 'hb-react/shared/components/LockScreen';

interface CreateMenteeToMentorFormProps {
  program: Program;
  mentor: MentorProfile;
  onSuccess: () => void;
}

export const CreateMenteeToMentorForm = ({
  program,
  mentor,
  onSuccess,
}: CreateMenteeToMentorFormProps) => {
  const { id: mentorId, name } = mentor;
  const { isLoading, mutateAsync } = useCreateMenteeToMentor({
    program,
    onSuccess,
  });

  const onSubmit = async (values: { message: string }) => {
    try {
      await mutateAsync({
        applicationMessage: values.message,
        mentorId: Number(mentorId),
      });
      // eslint-disable-next-line no-empty
    } catch {}
  };

  return (
    <Formik initialValues={{ message: '' }} onSubmit={onSubmit}>
      {() => (
        <Form>
          {isLoading && <LockScreen />}
          <MenteeToMentorFormContent
            program={program}
            mentorName={name}
            dataTestId="mentee-create-form"
          />
        </Form>
      )}
    </Formik>
  );
};
